const framework1 = `
&lt;div class="header">&lt;/div>
&lt;div class="main">
    &lt;div>&lt;/div>
    &lt;div>&lt;/div>
    &lt;div>&lt;/div>
&lt;/div>
&lt;div class="footer">&lt;/div>
 `
const framework2 = `
&lt;header>&lt;/header>
&lt;main>
    &lt;section>&lt;/section>
    &lt;section>&lt;/section>
    &lt;section>&lt;/section>
&lt;/main>
&lt;footer>&lt;/footer>
 `
const framework3 = `
.container {
    width: 1600px; // 根据设计稿来确定宽度
    margin-left: auto;
    margin-right: auto;
}
 `
const framework4 = `
&lt;header>
    &lt;div class="container">&lt;/div>
&lt;/header>
&lt;main>
    &lt;section>
        &lt;div class="container">&lt;/div>
    &lt;/section>
    &lt;section>
        &lt;div class="container">&lt;/div>
    &lt;/section>
    &lt;section>
        &lt;div class="container">&lt;/div>
    &lt;/section>
&lt;/main>
&lt;footer>
    &lt;div class="container">&lt;/div>
&lt;/footer>
 `

export default {
    framework1,
    framework2,
    framework3,
    framework4
}